import { AppPermissionLevels } from './app-permission-levels';

export interface IRoutesParamsTypes {
	_error: undefined;
	404: undefined;
	500: undefined;
	Login?: { src?: string };
	Dashboard: undefined;
	MyPolicies: undefined;
	AccountSettings: undefined;
	NotificationHistory: undefined;
	Quote: { journeyId?: string };
	QuoteExpired: undefined;
	QuoteAlreadyPurchased: undefined;
	QuoteOffline: { journeyId: string };
	QuoteMembers: { journeyId?: string };
	QuoteDeclaration: { journeyId: string };
	QuotePaymentPending: undefined;
	QuoteList: {
		journeyId: string;
		planTypeId?: number;
		sortId?: string;
		insurerCompanyId?: number;
		opConsultationCoPaymentId?: string[];
		networkId?: number[];
		pharmacyCoPaymentId?: string[];
		diagnosticCoPaymentId?: string[];
		keyBenefitId?: number[];
		investorOrPartner?: number;
	};
	EffectiveDateExpired: undefined;
	QuoteReview: { journeyId: string; quotePlanReferenceNumber: string };
	QuoteDocuments: { journeyId: string };
	QuoteDocumentsReview: { journeyId: string };
	DocumentError: { errorCode: string; journeyId: string };
	PendingUnPaidFines: undefined;
	QuotePayment: { journeyId: string };
	QuotePolicyIssuance: { journeyId: string };
	BlackListedUser: undefined;
	maf: { policyMemberMappingID: string };
	ManualPayment: { journeyId: string };
	ManualPaymentSuccess: { journeyId: string };
	RedirectFromIcp: undefined;
}

type TRoutesPermissions = {
	[key in keyof IRoutesParamsTypes]: {
		path: string;
		permissions: AppPermissionLevels[];
		parentRoute?: keyof IRoutesParamsTypes;
	};
};

export const routesPermissions: TRoutesPermissions = {
	_error: {
		path: '/_error',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	404: {
		path: '/404',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	500: {
		path: '/500',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	Login: {
		path: '/login',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	Dashboard: {
		path: '/account',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	MyPolicies: {
		path: '/account/policies',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	NotificationHistory: {
		path: '/account/notifications',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	AccountSettings: {
		path: '/account/settings',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	Quote: {
		path: '/individual-health-insurance/quote',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	QuoteExpired: {
		path: '/individual-health-insurance/quote/expired',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	QuoteOffline: {
		path: '/individual-health-insurance/quote/offline/[journeyId]',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuoteMembers: {
		path: '/individual-health-insurance/quote/members',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuotePaymentPending: {
		path: '/individual-health-insurance/quote/payment-pending',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuoteAlreadyPurchased: {
		path: '/individual-health-insurance/quote/already-purchased',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuoteDeclaration: {
		path: '/individual-health-insurance/quote/declaration/[journeyId]',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuoteList: {
		path: '/individual-health-insurance/quote/quote-list/[journeyId]',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	EffectiveDateExpired: {
		path: '/individual-health-insurance/quote/effective-date-expired',
		permissions: [AppPermissionLevels.AllLoggedInUser],
		parentRoute: 'Quote',
	},
	QuoteReview: {
		path: '/individual-health-insurance/quote/quote-review/[journeyId]/[quotePlanReferenceNumber]',
		permissions: [AppPermissionLevels.AnonymousUser],
		parentRoute: 'Quote',
	},
	QuoteDocuments: {
		path: '/individual-health-insurance/quote/documents/[journeyId]',
		permissions: [AppPermissionLevels.AllLoggedInUser],
		parentRoute: 'Quote',
	},
	QuoteDocumentsReview: {
		path: '/individual-health-insurance/quote/documents-review/[journeyId]',
		permissions: [AppPermissionLevels.AllLoggedInUser],
		parentRoute: 'Quote',
	},
	QuotePayment: {
		path: '/individual-health-insurance/quote/payment/[journeyId]',
		permissions: [AppPermissionLevels.AllLoggedInUser],
		parentRoute: 'Quote',
	},
	ManualPayment: {
		path: '/individual-health-insurance/manual-payment/[journeyId]',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	ManualPaymentSuccess: {
		path: '/individual-health-insurance/manual-payment/[journeyId]/success',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	QuotePolicyIssuance: {
		path: '/individual-health-insurance/quote/policy-issuance/[journeyId]',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	DocumentError: {
		path: '/individual-health-insurance/quote/documents/[journeyId]/[errorCode]',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	PendingUnPaidFines: {
		path: '/individual-health-insurance/quote/documents/[journeyId]/PendingUnPaidFines',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	BlackListedUser: {
		path: '/individual-health-insurance/quote/blacklisted-user',
		permissions: [AppPermissionLevels.AllLoggedInUser],
	},
	maf: {
		path: '/individual-health-insurance/maf/[policyMemberMappingID]',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
	RedirectFromIcp: {
		path: '/individual-health-insurance/quote/icp',
		permissions: [AppPermissionLevels.AnonymousUser],
	},
};
